// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fenge[data-v-e8638ca0]{height:30px;margin-top:20px;clear:both}.footer[data-v-e8638ca0]{background-color:#3e4753;padding:20px 0;clear:both}.footer .footerBox[data-v-e8638ca0]{width:1000px;margin:0 auto;color:#d2d2d2;font-size:16px;line-height:30px}.footer .footerBox span[data-v-e8638ca0]{margin-right:30px}", ""]);
// Exports
module.exports = exports;
